import React from 'react'
import { ChevronRight } from 'react-bootstrap-icons'

const InsuranceMegaMenu = ({ linkData }) => {
  return (
    <div className="flex w-inherit">
      <div className="flex-1">
        <div className="py-4 font-semibold uppercase leading-9 text-gray-800">
          <p>Insurance</p>
        </div>
        <div className="flex max-h-[423px] max-w-[660px] flex-wrap pb-6">
          {linkData?.items.map((insurance) => (
            <a
              href={insurance.link}
              className="mb-4 min-w-[220px] text-sm leading-[21px] !text-gray-700 hover:!text-gray-1100"
              key={insurance.name}
            >
              {insurance.name}
            </a>
          ))}
        </div>

        <div className="flex items-center">
          <a
            href="/insurance/"
            className="mb-4 flex flex-row !text-gray-800 hover:!text-gray-1100"
          >
            Browse All Insurance Providers
            <ChevronRight className="ml-5 mt-0.5 size-4" />
          </a>
        </div>
      </div>
    </div>
  )
}

export default InsuranceMegaMenu
